import {Dropdown, DropdownOptionProps, DropdownTheme} from 'wix-ui-tpa/cssVars';
import React, {useMemo} from 'react';
import {ILocaleKeys, useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {Plus} from '@wix/wix-ui-icons-common/on-stage';
import {AddressWithContactModel} from '../../../../domain/models/checkout/Cart/AddressWithContact.model';
import {ADD_NEW_ADDRESS_ID} from '../../constants';
import {useMemberDetailsData} from '../WithMemberDetailsData';
import {BiAddressActionOrigin} from '../../../../domain/utils/bi.util';
import {classes} from './AddressDropdown.st.css';

export enum AddressDropdownDataHook {
  root = 'AddressDropdown.root',
  dropdown = 'AddressDropdown.dropdown',
}

export const AddressDropdown = ({dropdownLabel}: {dropdownLabel: string}) => {
  const {
    memberStore: {addressesInfo, reportAddAddressClicked},
    checkoutStore: {cart},
    stepsManagerStore: {activeStep},
  } = useControllerProps();

  const localeKeys = useLocaleKeys();
  const {selectedAddressesServiceId, setAddressServiceById} = useMemberDetailsData();
  const onSelect = ({id}: DropdownOptionProps) => {
    if (id === ADD_NEW_ADDRESS_ID) {
      reportAddAddressClicked({
        cart,
        origin: BiAddressActionOrigin.UserIntent,
        stage: activeStep.stepId,
      });
    }
    setAddressServiceById(id);
  };
  const options = useMemo(() => mapToDropdownOptions(addressesInfo.addresses, localeKeys), [addressesInfo, localeKeys]);

  return (
    <div data-hook={AddressDropdownDataHook.root} className={classes.root}>
      <Dropdown
        className={classes.dropdown}
        data-hook={AddressDropdownDataHook.dropdown}
        label={dropdownLabel}
        key={selectedAddressesServiceId}
        initialSelectedId={selectedAddressesServiceId}
        upgrade={true}
        disabled={selectedAddressesServiceId === ADD_NEW_ADDRESS_ID}
        theme={DropdownTheme.Box}
        options={options}
        onChange={onSelect}
      />
    </div>
  );
};

const mapToDropdownOptions = (addresses: AddressWithContactModel[], localeKeys: ILocaleKeys) => {
  const dropdownOptions: DropdownOptionProps[] = addresses.map((address) => {
    return {
      id: address?.addressId,
      value: address.address?.streetAddress?.name
        ? `${address.address?.streetAddress?.name} ${
            address.address?.streetAddress?.number ?? /* istanbul ignore next */ ''
          }`
        : address.address?.addressLine,
      subtitle: localeKeys.checkout.customerName.label({
        firstName: address.contact?.firstName,
        lastName: address.contact?.lastName,
      }),
      isSelectable: true,
    };
  });
  dropdownOptions.push({
    isSelectable: true,
    id: ADD_NEW_ADDRESS_ID,
    value: localeKeys.checkout.member.addressDropdown.addNewAddress.cta(),
    icon: <Plus />,
  });
  return dropdownOptions;
};
